import { useEffect, useState } from "react";
import { MdClose, MdChevronLeft, MdChevronRight, MdMoreHoriz } from "react-icons/md";
import DeletePost from "./DeletePost";

export default function PhotoViewer({
    images = [],
    currentIndex,
    onClose,
    onPrev,
    onNext,
    showMenuOption,
    onDeleteImage
}) {

    const [showPopup, setShowPopup] = useState(false);

    // Keyboard navigation
    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Escape") onClose();

            if (e.key === "ArrowLeft" && currentIndex > 0) {
                onPrev();
            }

            if (e.key === "ArrowRight" && currentIndex < images.length - 1) {
                onNext();
            }
        };

        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [onClose, onPrev, onNext, currentIndex, images.length]);

    if (!images.length) return null;

    const currentItem = images[currentIndex];
    if (!currentItem) return null;

    const OnDeletePost = (postId) => {
        setShowPopup(false);
        onDeleteImage?.(postId);
    }

    return (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">

            {/* CLOSE */}
            <button
                onClick={onClose}
                className="absolute top-6 left-6 text-white text-3xl"
            >
                <MdClose />
            </button>

            {/* MENU (3 dots) */}
            {showMenuOption &&
                <button
                    onClick={() => setShowPopup(true)}
                    className="absolute top-6 right-6 text-white text-3xl">
                    <MdMoreHoriz />
                </button>
            }

            {/* PREV */}
            {currentIndex > 0 && (
                <button
                    onClick={onPrev}
                    className="absolute left-4 text-white text-5xl"
                >
                    <MdChevronLeft />
                </button>
            )}

            {/* IMAGE */}
            <img
                src={currentItem.url}
                className="w-full h-full object-contain"
                alt=""
            />

            {/* NEXT */}
            {currentIndex < images.length - 1 && (
                <button
                    onClick={onNext}
                    className="absolute right-4 text-white text-5xl"
                >
                    <MdChevronRight />
                </button>
            )}

            <DeletePost
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
                onDelete={() => OnDeletePost(currentItem.id)}
            />

        </div>
    );
}